export enum GUARDS {
  IS_STEP_BEFORE_REGISTER = 'IS_STEP_BEFORE_REGISTER',
  IS_STEP_AFTER_REGISTER = 'IS_STEP_AFTER_REGISTER',
  IS_STEP_REGISTER = 'IS_STEP_REGISTER',
  IS_AUTHENTICATED = 'IS_AUTHENTICATED',
  IS_NOT_AUTHENTICATED = 'IS_NOT_AUTHENTICATED',
}

export const buildGuards = () => ({
  [GUARDS.IS_AUTHENTICATED]: ({ context }) => context.isAuthenticated,
  [GUARDS.IS_NOT_AUTHENTICATED]: ({ context }) => !context.isAuthenticated,
  [GUARDS.IS_STEP_AFTER_REGISTER]: ({ context }) =>
    context.currentStepIndex > context.registerStepIndex,
  [GUARDS.IS_STEP_BEFORE_REGISTER]: ({ context }) =>
    context.currentStepIndex < context.registerStepIndex,
  [GUARDS.IS_STEP_REGISTER]: ({ context }) =>
    context.currentStepIndex === context.registerStepIndex,
});
